import {
  FunnelNavigationContext,
  EventContextArea,
} from "../components/funnel/types";
import { Comic, Release } from "../types";
import { useMemo } from "react";
import { useHookstate } from "@hookstate/core";
import { rootComponentsStore } from "../hookstate/rootComponentsStore";
import { readerDataStore } from "../hookstate/readerDataStore";

export function useGetNavigationContext({
  contextArea,
  release,
  comic,
  artistId,
}: {
  contextArea: EventContextArea;
  release?: Release;
  comic?: Comic;
  artistId?: number;
}): FunnelNavigationContext {
  let releaseData = useHookstate(readerDataStore.releaseData).get();
  let comicData = useHookstate(readerDataStore.comicData).get();
  const contextReferrer = rootComponentsStore.eventContextReferrer.get();

  return useMemo<FunnelNavigationContext>(() => {
    const currentRelease = release ?? releaseData;
    const currentComic =
      release?.comic ?? comic ?? releaseData?.comic ?? comicData;

    return {
      contextArea,
      contextReferrer,
      data: {
        comicId: currentComic?.id,
        comicName: currentComic?.name,
        releaseId: currentRelease?.id,
        releaseOrder: currentRelease?.order,
        ppbPricePoint: currentRelease?.ppb_price_point,
        ppbGoldPricePoint: currentRelease?.ppb_gold_price_point,
        premiumOnly: currentRelease?.premium_only ? 1 : 0,
        artistId,
      },
    };
  }, [contextArea, artistId, releaseData, comicData, release, comic, contextReferrer]);
}
